import { useState, useRef, useEffect } from "react";
import { aiApi } from "./services/aiApi";

export default function AiChatPanel({ T, user }) {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const listRef = useRef(null);

  useEffect(() => {
    if (listRef.current) listRef.current.scrollTop = listRef.current.scrollHeight;
  }, [messages, open]);

  const send = async () => {
    const text = input.trim();
    if (!text || loading) return;
    const next = [...messages, { role: "user", content: text }];
    setMessages(next);
    setInput("");
    setLoading(true);
    setError(null);
    try {
      const { reply } = await aiApi.chat(next);
      setMessages(m => [...m, { role: "assistant", content: reply }]);
    } catch (e) {
      setError(e.message);
    }
    setLoading(false);
  };

  const onKeyDown = e => {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); }
  };

  return (
    <>
      <button onClick={() => setOpen(o => !o)}
        style={{ position:"fixed", bottom:24, left:24, zIndex:900, width:52, height:52, borderRadius:"50%", background:T.accent, border:"none", color:"#fff", fontSize:22, cursor:"pointer", boxShadow:`0 8px 24px ${T.accent}55`, display:"flex", alignItems:"center", justifyContent:"center" }}
        title="Assistant IA">
        {open ? "✕" : "✨"}
      </button>

      {open && (
        <div style={{ position:"fixed", bottom:86, left:24, zIndex:900, width:360, maxWidth:"calc(100vw - 48px)", height:480, maxHeight:"70vh", background:T.card, border:`1px solid ${T.border}`, borderRadius:16, boxShadow:"0 12px 40px rgba(0,0,0,0.3)", display:"flex", flexDirection:"column", overflow:"hidden" }}>
          <div style={{ padding:"13px 16px", borderBottom:`1px solid ${T.border}`, display:"flex", alignItems:"center", gap:8 }}>
            <span style={{ fontSize:16 }}>✨</span>
            <div style={{ fontSize:13, fontWeight:800, color:T.text, flex:1 }}>Assistant GS GROUP</div>
            <button onClick={() => setOpen(false)} style={{ background:"none", border:"none", color:T.muted, cursor:"pointer", fontSize:16 }}>✕</button>
          </div>

          <div ref={listRef} style={{ flex:1, overflowY:"auto", padding:"12px 14px", display:"flex", flexDirection:"column", gap:10 }}>
            {messages.length === 0 && (
              <div style={{ fontSize:12.5, color:T.muted, textAlign:"center", marginTop:20 }}>
                Bonjour {user?.prenom||""} 👋<br/>Pose-moi une question sur les tickets, interventions, ou le stock.
              </div>
            )}
            {messages.map((m, i) => (
              <div key={i} style={{ alignSelf: m.role==="user" ? "flex-end" : "flex-start", maxWidth:"85%", background: m.role==="user" ? T.accent : T.bg, color: m.role==="user" ? "#fff" : T.text, border: m.role==="user" ? "none" : `1px solid ${T.border}`, borderRadius:12, padding:"8px 12px", fontSize:13, lineHeight:1.5, whiteSpace:"pre-wrap" }}>
                {m.content}
              </div>
            ))}
            {loading && <div style={{ fontSize:12, color:T.muted, alignSelf:"flex-start" }}>⏳ Recherche en cours…</div>}
            {error && <div style={{ fontSize:12, color:T.danger||"#ef4444", alignSelf:"flex-start" }}>{error}</div>}
          </div>

          <div style={{ padding:"10px 12px", borderTop:`1px solid ${T.border}`, display:"flex", gap:8 }}>
            <textarea value={input} onChange={e=>setInput(e.target.value)} onKeyDown={onKeyDown} rows={1} placeholder="Écris ta question…"
              style={{ flex:1, resize:"none", background:T.bg, border:`1px solid ${T.border}`, borderRadius:9, padding:"8px 11px", color:T.text, fontSize:13, outline:"none", fontFamily:"inherit" }}/>
            <button onClick={send} disabled={loading||!input.trim()} style={{ padding:"0 14px", borderRadius:9, border:"none", background:T.accent, color:"#fff", fontSize:13, fontWeight:700, cursor:"pointer", opacity:(loading||!input.trim())?0.5:1 }}>
              ➤
            </button>
          </div>
        </div>
      )}
    </>
  );
}
